import React, {useEffect, useState} from 'react'
import {Card, Row, Col} from "antd";
import './style.css';

const InfoPageComp = () => {

    return (
        <div className="site-card-wrapper">

            <Row gutter={16}>
                <Col span={8}>
                    <Card title="Card title" bordered={false}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/plot1.png?token=AI26VIGK2JULQLVN4VI4JC3AC3M2Y"/>
                          }>
                        (Upper) Calibration plots for COVID-19 predictions for 4 models (LR, NB, SV, RF) on hold out validation data set;
                        Below the diagonal: The model has over-forecast; the probabilities are too large. Above the diagonal: The model
                        has under-forecast; the probabilities are too small. (Lower) Predicted probabilities are divided
                        up into a fixed number of buckets along the x-axis. The number of events (class=1) are then counted
                        for each bin (e.g. the relative observed frequency). Finally, the counts are normalized. The results are
                        then plotted as a line plot.
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="Model Plot" bordered={false}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/plot2.png?token=AI26VICZV5CRZHANAADX26DAC3M3A"/>
                          }>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="Model Plot" bordered={false}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/plot3.png?token=AI26VIDPYNTGXU7XTYTHSBTAC3M3G"/>
                          }>
                        add: Number  of true positives, false positives, true negatives and false negatives on test data for COVID prediction (upper lefts, upper right, lower left, lower right respectively)
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="Model Plot" bordered={false}
                          style={{ marginTop: 16 }}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/plot4.png?token=AI26VIA5WPEWVSTUNXWMVWDAC3M3M"/>
                          }>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="Model Plot" bordered={false}
                          style={{ marginTop: 16 }}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/plot5.png?token=AI26VID5HPE774K7QB3HHDTAC3M3S"/>
                          }>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="Model Plot" bordered={false}
                          style={{ marginTop: 16 }}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/plot6.png?token=AI26VICDIQHMNAOQ5MM6SQTAC3M32"/>
                          }>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="Model Plot" bordered={false}
                          style={{ marginTop: 16 }}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/plot7.png?token=AI26VIHE7SQZDU75BIOJSA3AC3M4A"/>
                          }>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="Model Plot" bordered={false}
                          style={{ marginTop: 16 }}
                          cover={
                              <img src="https://raw.githubusercontent.com/rainasong/HexCam2021/master/hexcam-project/src/Resources/plot8.png?token=AI26VIE3UBCQ6YTI2Q6DLCDAC3M4G"/>
                          }>
                        AUC and ROC curve for the VGG-16 CNN on hold out test data set for pneumonia predictions. AUC = 0.976.
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default InfoPageComp
